<template>
  <Modal @close="close(false)">
    <div v-if="error" slot="header">
      <h1>Noget gik galt.</h1>
    </div>
    <div v-else-if="!sendingToGeoDk && sagId === 0" slot="header">
      <h1>Bekræft opdatering</h1>
    </div>
    <div v-else-if="sendingToGeoDk" slot="header">
      <h1>Sender til GeoDK</h1>
    </div>
    <div v-else-if="!sendingToGeoDk && sagId > 0" slot="header">
      <h1>Sag sendt til GeoDK</h1>
    </div>
    <div class="danger" v-if="error" slot="body">
      {{error}}
    </div>
    <div v-else-if="!sendingToGeoDk && sagId === 0" slot="body">
      <h2>GeoDK-objekter som opdateres</h2>
      <table class="table-vejkode-selected" style="width:100%">
        <tr>
          <th class="col-vejkode">Vejkode</th>
          <th>Vejnavn</th>
          <th>GeoDK objekt</th>
        </tr>
        <tr v-for="objekt in geoDkObjekter" :key="objekt.get('geoDkId')">
          <td class="col-vejkode vejkode-selected" v-if="objekt.get('adressering')">{{objekt.get('vejkode')}}</td>
          <td class="col-vejkode vejkode-selected" v-else>(Ingen)</td>
          <td v-if="objekt.get('adressering')">{{objekt.get('adressering').navn}}, {{objekt.get('adressering').postnr}}</td>
          <td v-else></td>
          <td>{{objekt.get('geoDkId')}}</td>
        </tr>
      </table>
      <h2>Vejkoder rettes til</h2>
      <table class="col-vejkode table-vejkode-ny" style="width:100%">
        <tr>
          <th>Vejkode</th>
          <th>Vejnavn</th>
        </tr>
        <tr>
          <td class="col-vejkode vejkode-ny" v-if="currentVejkode">{{currentVejkode.toString().padStart(4, '0')}}</td>
          <td class="col-vejkode vejkode-ny" v-else>(Ingen)</td>
          <td>{{adressering}}</td>
        </tr>
      </table>
      <h2>Tilføj eventuelt en kommentar til sagen i GeoDK</h2>
      <textarea v-model="opdatering.kommentar" placeholder="Skriv her ..." />
    </div>
    <div v-else-if="sendingToGeoDk" slot="body"></div>
    <div v-else-if="!sendingToGeoDk && sagId > 0" slot="body">
      Se sagen i <a target="geodkeditor" v-bind:href="'https://editor-test-api.services.geodanmark.nu/sager/' + sagId">GeoDK</a>.
    </div>

    <div v-if="error" slot="footer" class="footer">
      <Button :onClick="close.bind(this, false)" :text="'OK'" />
    </div>
    <div v-else-if="!sendingToGeoDk && sagId === 0" slot="footer" class="footer">
      <Button :onClick="close.bind(this, false)" :text="'Afbryd'" :outline="true" />
      <Button :onClick="sendVejkode" :text="'Send til GeoDK'" />
    </div>
    <div v-else-if="sendingToGeoDk" slot="footer" class="footer">
      Vent lige ...
    </div>
    <div v-else-if="!sendingToGeoDk && sagId > 0" slot="footer" class="footer">
      <Button :onClick="close.bind(this, true)" :text="'OK'" />
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/common/Modal.vue';
import Button from '@/components/common/Button.vue';
export default {
  name: 'confirmation-modal',
  components: {
    Modal,
    Button,
  },
  props: {
    geoDkObjekter: Array,
    sendingToGeoDk: Boolean,
    close: Function,
    sagId: Number,
    opdatering: Object,
    adressering: String,
    currentVejkode: Number,
    error: String,
    sendVejkode: Function,
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 20px;
}
.modal-header{
  h1 {
    font-size: 15px;
  }
}

table {
  /* font-family: arial, sans-serif; */
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 40px;
}

td, th {
    text-align: left;
    padding: 8px 0;
}

.table-vejkode-selected {
  td, th {
    border-bottom: 1px solid rgba( $selected-color, .3 );
  }
}
.table-vejkode-ny {
  td, th {
    border-bottom: 1px solid rgba( $default-color, .3 );
  }
}

.modal-header h1,h2,h3 {
  text-align: left;
}
.modal-body h1,h2,h3 {
  text-align: left;
  color: rgba(0,0,0,0.85);
}

.footer {
  margin: -10px -10px 0 0;
}
.vejkode-selected {
  color: $selected-color;
}
.vejkode-ny {
  color: $default-color;
}

.col-vejkode {
  width: 110px;
}

textarea {
  background-color: rgba(121,56,208,0.05);
  font-family: 'Open Sans', 'sans-serif';
  font-size: 16px;
  width: 100%;
  border: 1px solid #E7EBFA;
  border-radius: 2px;
  padding: 8px 14px;
  min-height: 80px;
}
textarea:focus {
  background-color: #FFFFFF;
  outline: 1px solid $default-color;
}

.danger {
  color: $danger-color;
}
</style>
